import breakpoints from './breakpoints'

export const devices = {
  tablet: breakpoints.md,
  desktop: breakpoints.xl
}
